import React from "react";
import { useTranslation } from "react-i18next";

export default function NotFound() {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen bg-main bg-no-repeat bg-cover text-white flex flex-col items-center justify-center px-4 md:px-16 lg:px-24">
            <div className="text-center">
                <h1 className="font-notoSans text-8xl md:text-[12rem] lg:text-[16rem] leading-none text-white font-bold">
                    404
                </h1>
                <h2 className="font-notoSans text-3xl md:text-5xl lg:text-6xl text-white mt-4 font-semibold">
                    {t("notFound.title")}
                </h2>
                <p className="font-notoSans text-lg md:text-xl text-black mt-6 max-w-md mx-auto">
                    {t("notFound.message")}
                </p>
                <a
                    href="/"
                    className="inline-block mt-8 px-8 py-4 bg-brandDarkGreen text-white font-notoSans font-bold rounded-lg shadow-lg hover:bg-opacity-90 transition-all duration-300"
                >
                    {t("notFound.backHome")}
                </a>
            </div>
        </div>
    );
}
